export default {
  FETCH_BUY_REPORT: 'FETCH_BUY_REPORT',
  FETCH_BUY_REPORT_SUCCESS: 'FETCH_BUY_REPORT_SUCCESS',
  DOWNLOAD_BUY_REPORT: 'DOWNLOAD_BUY_REPORT'
}
